<mat-card class="cardWithShadow" style="margin: 0; height: 100%;overflow: hidden;border-radius: 0;">
    <mat-card-header class="w-100 d-block p-0" style="background-color: #1e293b;border-bottom: 3px solid #5d87ff;">
      <mat-card-title>
        <div class="w-100 d-flex" style="background: #0f172a;">
          <span style="display: flex; align-items: center; margin-left: 15px; color: #1bbaee; font-size: 14px;">
            Clavier
          </span> 
          <button class="m-l-auto" mat-icon-button (click)="onClose();">
            <i-tabler name="x" class="icon-18" style="color: #1bb3e6;"></i-tabler>
          </button>
        </div>
      </mat-card-title>
      <mat-card-title>
        <mat-form-field class="w-100" style="background: #0f172a;">
          <input matInput type="number" [autocomplete]="'off'" [(ngModel)]="numpadValue" style="color: black; font-size: 65px; margin-left: auto; text-align: end; margin-right: 20px;" disabled>
        </mat-form-field>
        <div style="border-right: 2px solid #1855d5; margin-right: 15px;position: absolute;top: 80px;">
          <button mat-icon-button>
            <i-tabler name="123" class="icon-24 d-flex" style="color: #1cc8ff; align-items: center;"></i-tabler>
          </button>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content style="flex: 1;padding: 0;">
      <div>
        <div class="md-numpad-row-wrapper">
            <ng-container *ngFor="let key of numpadKeys">
                <ng-container [ngSwitch]="key">
                    <ng-container *ngSwitchCase="'Backspace'">
                        <button mat-stroked-button class="md-numpad-button" (click)="onNumpadClickAction_Numpad('Backspace');">  
                            <i-tabler name="backspace" class="icon-48" style="color: #1cc8ff; align-items: center;"></i-tabler>
                        </button>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Clear'">
                        <button mat-stroked-button class="md-numpad-button" (click)="clearValue()">  
                            <i-tabler name="square-x" class="icon-48" style="color: #ff4343; align-items: center;"></i-tabler>
                        </button>
                    </ng-container>
                    <ng-container *ngSwitchCase="null">
                        <button mat-stroked-button class="md-numpad-button" [disabled]="true">  </button>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <button mat-stroked-button class="md-numpad-button" (click)="onNumpadClickAction_Numpad(key!)"> {{ key }} </button>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions class="d-block m-0 p-0" style="background-color: #0f172a;border-top: 3px solid #5d87ff;">
      <div class="d-flex w-100" style="border-right: 3px solid #1855d5; margin-right: 15px;height: 100px;">
        <button mat-stroked-button style="color: #707387; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1; margin-top: auto; margin-bottom: auto; height: 80px;" (click)="onClose()">
          {{ "ANNULER" | translate }}
        </button>
        <button mat-stroked-button class="ccmainfo" (click)="onSubmit();" [disabled]="!isValid()" style="color: #1bbaee; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1; margin-top: auto; margin-bottom: auto; height: 80px;">
          {{ "VALIDER" | translate }}
        </button>
      </div>
    </mat-card-actions>
  </mat-card>